
import React from 'react'
import { FiCheck  } from "react-icons/fi"
import { Thumbs  } from "../../../@shared/elements/thumbs"

export const RequestItemCoPilot = ({item}) => {

    return (
        <li>
            <div className="owner">
                <a href={`/users/${item.from._id}`} className="name">{item.from.name}</a>
                <a href={`/users/${item.from._id}`}>
                    {item.from.avatar && <img src={`/assets/images/${ item.from.avatar}`} alt={item.from.name} draggable="false"  />}
                    {!item.from.avatar && <img src="/assets/images/faces/default.svg"  alt={item.from.name} draggable="false"  /> }
                </a>
                <p className="date">{item.user.date}</p>
                <div className="thumbs">
                    <Thumbs
                        id={item?.from?._id}
                        likes={item?.from?.likes?.length}
                        dislikes={item?.from?.dislikes?.length} 
                    />  
                </div>
            </div>
            <div className="detail">
                <p className="title"> {item.to?.type} your areas of expertise</p>
                <ul className="flex-start">
                    {item.to?.job?.map((job,i)=>(
                       <li key={'job'+i} className="flex-start">
                           <div className="checkbox"><FiCheck /> </div>
                           {job.title}
                       </li>
                    ))}                        
                </ul>
                <p className="title"> {item.to?.type} services</p>
                <ul className="flex-start">
                    {item.to?.workstyle?.map((workstyle,i)=>( 
                        <li key={'work'+i} className="flex-start">
                            <div className="checkbox"><FiCheck /> </div>
                            {workstyle.title}
                        </li>

                    ))}
                </ul>
                <p className="title"> {item.to?.type} areas</p>
                <ul className="flex-start">
                    {item.to?.sector?.map((sector,i)=>(
                        <li key={'sector'+i} className="flex-start">
                            <div className="checkbox"><FiCheck /> </div>
                            {sector.title}
                        </li>
                    ))}
                </ul>


                <div className="flex-end mt-2 mb-3">
                     {item.status===4 && <div className="button red" >Cancel</div> }
                     {item.status===1 && <div className="button green" >Accept</div>   }
                </div>
            </div>
        </li>
    )
}
